export default {
  visitName: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },

  active: {
    value: null,
    maxlength: '100',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/visit-type/components/add/visit-type-form.js